import {useEffect, useRef} from "react";

export const ExternalAdFallback = ({config, onAdFill}) => {
  const {width, height, adSenseId} = config;
  const ref = useRef(null);

  useEffect(() => {
    (window.adsbygoogle = window.adsbygoogle || []).push({});


    if (ref.current && ref.current.offsetHeight > 0 && ref.current.offsetWidth > 0) {
      onAdFill(true);
    } else {
      onAdFill(false);
    }
  }, []);

  if(!adSenseId) {
    return null;
  }

  return  (
      <div>
        <ins className="adsbygoogle" style={{display: 'inline-block', width: width, height: height}}
             data-ad-client="ca-pub-8672827648650156"
            data-ad-slot={adSenseId} ref={ref}>
        </ins>
      </div>
  );
};
